import { createApi, fakeBaseQuery } from '@reduxjs/toolkit/query/react'
import pako from 'pako'

import { FeatureType } from 'clickNgo/configs/feature'
import { getAccessToken } from 'cng-common/helpers/access'
import settings from 'src/config/settings'

import type { PBMDashboardResponse } from '../model/types'

export const pbmDashboardApi = createApi({
  reducerPath: `${FeatureType.P360Api}/pbmDashboardApi`,
  baseQuery: fakeBaseQuery(),
  tagTypes: ['PBMDashboard'],
  endpoints: (build) => ({
    getPBMDashboardGzip: build.query<PBMDashboardResponse, void>({
      providesTags: [{ type: 'PBMDashboard', id: 'api' }],
      queryFn: async () => {
        try {
          const url = `${settings.httpsServices.partner360}/api/v0/pbmDashboard/pbmDashboardGzip`
          const accessToken = getAccessToken()

          const response = await fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${accessToken}`,
            },
            body: JSON.stringify({}),
          })

          if (!response.ok) {
            return { error: { status: response.status, data: response.statusText } }
          }

          const gzipData = await response.arrayBuffer()

          const ungzipped = pako.ungzip(new Uint8Array(gzipData))
          const unpackedData = new TextDecoder('utf-16le').decode(ungzipped)
          const parsedData = JSON.parse(unpackedData) as PBMDashboardResponse

          return { data: parsedData }
        } catch (error) {
          return { error: { status: 'CUSTOM_ERROR', data: String(error) } }
        }
      },
    }),
  }),
})

export const { useGetPBMDashboardGzipQuery } = pbmDashboardApi
